/*eslint-disable */
import axios from 'axios';
import root from '../_helpers/roots';
let dataUrl = root.quizBannerLink.link;

export default {
  state: {
    quizBannerData: {}
  },
  mutations: {
    setQuizBanner(state, value) {
      state.quizBannerData = value;
    }
  },
  actions: {
    getQuizBannerData(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get(dataUrl)
          .then(function(response) {
            context.commit('setQuizBanner', response.data);
            resolve(response.data);
          })
          .catch(
            function(err) {
              reject(err);
            }
          )
      })
    }
  },
  getters: {
    getQuizBannerGetter: state => state.quizBannerData
  }
}
